import {enableProdMode, ErrorHandler, importProvidersFrom} from '@angular/core';


import {environment} from './environments/environment';
import {AppErrorHandler} from './app/common/errors-handler.service';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {RefHttpInterceptor} from './app/common/ref-http.interceptor';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app/app-routing.module';
import {MaterialModule} from './app/material/material.module';
import {FormsModule} from '@angular/forms';
import {AppComponent} from './app/app.component';
import {KlntHasura} from './app/core/hasura-client';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, MaterialModule, FormsModule),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefHttpInterceptor,
            multi: true
        },
        {provide: KlntHasura},

    ]
})
    .catch(err => {
        console.error('Unhandled Error: ', err);
    });
